import { styled as e, Box as h } from "@mui/material";
import { SkeletonTypography as u } from "../../temp-lib/components/share/generic/Skeleton.js";
import x from "../../temp-lib/components/share/next/Image.js";
import { PlatformType as w } from "../../temp-lib/constants/platform.js";
import { format as g } from "date-fns";
import * as r from "ramda";
import { useMemo as m } from "react";
import { useTranslation as k } from "react-i18next";
import { jsxs as y, jsx as s } from "react/jsx-runtime";
const b = e(h)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
  text-align: center;
  ${(t) => t.theme.breakpoints.up("res768")} {
    aspect-ratio: 763/73;
    gap: 4px;
    width: 700px;
  }
  ${(t) => t.theme.breakpoints.down("res768")} {
    aspect-ratio: 763/100;
    width: 500px;
  }
`, $ = e(x)`
  position: absolute;
  height: 100%;
  width: 100%;
`, d = e(u)`
  color: #979a9d;
  font-weight: 300;
  position: relative;
  ${(t) => t.theme.breakpoints.up("res768")} {
    line-height: 16px;
  }
  ${(t) => t.theme.breakpoints.down("res768")} {
    font-size: 12px;
    line-height: 12px;
  }
  .Custom-Skeleton {
    margin: 0 auto;
    max-width: 200px;
  }
`, v = e(d)`
  color: white;
  font-weight: 700;
  ${(t) => t.theme.breakpoints.up("res768")} {
    margin-top: 8px;
  }
  ${(t) => t.theme.breakpoints.down("res768")} {
    margin-top: 15px;
  }
  .Custom-Skeleton {
    margin: 0 auto;
    max-width: 320px;
  }
`, I = (t) => {
  const {
    background: l,
    infoList: a
  } = t, o = m(() => r.find((n) => n.platform.type === w.Window, a), [a]), {
    t: p
  } = k(), c = m(() => {
    if (r.isNotNil(o)) {
      const n = o.build.lastUpdated || 0, f = new Date(n);
      return g(f, "MMM dd, yyyy");
    }
    return "";
  }, [o]), i = r.isNil(o);
  return /* @__PURE__ */ y(b, {
    children: [/* @__PURE__ */ s($, {
      src: l
    }), /* @__PURE__ */ s(v, {
      loading: i,
      children: p("download.client_version", {
        version: i ? "" : o.build.version
      })
    }), /* @__PURE__ */ s(d, {
      loading: i,
      children: p("download.last_update", {
        date: c
      })
    })]
  });
};
export {
  I as default
};
//# sourceMappingURL=DownloadLastUpdate.js.map
